import styled from 'styled-components'

import { Location } from './Location'
import { Shared } from './Shared'

const getTransformOrigin = (location: Location) => {
	switch (location) {
		case Location.Top:
			return 'top'
		case Location.Bottom:
			return 'bottom'
		case Location.Right:
			return 'right'
		case Location.Left:
			return 'left'
	}
}

const getAfterTranslate = (location: Location) => {
	switch (location) {
		case Location.Top:
		case Location.Bottom:
			return 'translateX(-50%)'
		case Location.Right:
		case Location.Left:
			return 'translateY(50%)'
	}
}

const getAfterScale = (amount: number, location: Location) => {
	switch (location) {
		case Location.Top:
		case Location.Bottom:
			return `scaleY(${amount})`
		case Location.Right:
		case Location.Left:
			return `scaleX(${amount})`
	}
}

type Props = {
	location: Location
	transitionDuration: number
}

export const Arrow = styled(Shared)<Props>`
	border-style: solid;
	border-width: ${({ location }) => {
		switch (location) {
			case Location.Top:
				return '5px 5px 0px 5px'
			case Location.Bottom:
				return '0px 5px 5px 5px'
			case Location.Right:
				return '5px 5px 5px 0px'
			case Location.Left:
				return '5px 0px 5px 5px'
		}
	}};
	border-color: ${({ theme, location }) => {
		switch (location) {
			case Location.Top:
				return `${theme.color.cardBackground} transparent transparent transparent`
			case Location.Bottom:
				return `transparent transparent ${theme.color.cardBackground} transparent`
			case Location.Right:
				return `transparent ${theme.color.cardBackground} transparent transparent`
			case Location.Left:
				return `transparent transparent transparent ${theme.color.cardBackground}`
		}
	}};
	transition-duration: 0s;
	transform-origin: ${({ location }) => getTransformOrigin(location)};
	transform: ${({ location }) => getAfterTranslate(location)} ${({ location }) => getAfterScale(0, location)};

	#tooltip-wrapper:hover & {
		visibility: visible;
		opacity: 1;
		transition-delay: ${({ transitionDuration }) => transitionDuration}ms;
		transition-duration: ${({ transitionDuration }) => transitionDuration}ms;
		transform: ${({ location }) => getAfterTranslate(location)} ${({ location }) => getAfterScale(1, location)};
	}
`
